import { SET_DSR_TEMPLATE_ID } from '../../actions/dsr-template-actions-types'

const INITIAL_STATE_SET_DSR_TEMPLATE_ID = { results: '', isRoomTemplate: "" }

export function setDsrTemplateIdReducer(state = INITIAL_STATE_SET_DSR_TEMPLATE_ID, action) {
    switch (action.type) {
        case SET_DSR_TEMPLATE_ID:
            return { results: action.payload, isRoomTemplate: action.payload ? true : false }
        default:
            return state;
    }
}